import $ from 'jquery';

import Client from 'shopify-buy';
import Cookie from 'js-cookie';
import _ from 'lodash/function'

export default class Shopify_ {
    constructor(apiKey, domain) {
        this.apiKey = apiKey;
        this.domain = domain;
        this.cartIcon = '';
        this.cartContainer = '';
        this.checkoutId = '';
        this.checkoutUrl = '';

        this.cookie = Cookie.get('myCartId');

        this.shopifyClient = Client.buildClient({
            domain: this.domain,
            storefrontAccessToken: this.apiKey,
        });
    }

    shopifyPromise() {
        const t = this;

        return new Promise(function(resolve, reject) {
            if(t.shopifyClient) {
                resolve('success');
            } else {
                reject('rejected');
            }
        });
    }

    getCookie() {
        return this.cookie;
    }

    setCookie(id) {
        Cookie.set('myCartId', id, { expires: 1 });
    }

    setupSubTotal(price) {
        // console.log(price);
        $('.cart-buttons_price').html('$' + price);
    }

    toggleCart() {

        const t = this;

        if(t.cartContainer.hasClass('is-open')) {
            t.cartContainer.removeClass('is-open');
            t.cartContainer.addClass('is-closing');
            
            setTimeout(()=>{
                t.cartContainer.removeClass('is-closing');
                t.cartContainer.addClass('is-closed');
            }, 900);
        } else {
            t.cartContainer.addClass('is-open');

            if(t.cartContainer.hasClass('is-closed')) {
                setTimeout(()=>{                    
                    t.cartContainer.removeClass('is-closed');
                }, 300);
            }
        }
    }

    setupCartIcon(iconClass) {
        const t = this;

        this.cartIcon = $(iconClass);
        const closetHe = $(this.cartIcon.closest('.header_button'));
        closetHe.off('click');
        $('.cart-heading_close, .cart_bg, .cart-close').off('click');

        function close(el){
            // if(t.cartContainer.hasClass('is-open')) {
            //     t.cartContainer.removeClass('is-open');
            //     t.cartContainer.addClass('is-closing');
                
            //     setTimeout(()=>{
            //         t.cartContainer.removeClass('is-closing');
            //         t.cartContainer.addClass('is-closed');
            //     }, 900);
            // } else {
            //     t.cartContainer.addClass('is-open');

            //     if(t.cartContainer.hasClass('is-closed')) {
            //         setTimeout(()=>{                    
            //             t.cartContainer.removeClass('is-closed');
            //         }, 300);
            //     }
            // }

            t.toggleCart();
        }
        
        closetHe.click(close);
        $('.cart-heading_close, .cart_bg, .cart-close').click(close);
    }

    updateCartIcon(data) {

        var num = 0;

        if(data.length > 0) {
            data.forEach((el)=>{
                num = num + el.quantity;
            });
    
            if(num > 9) {
                this.cartIcon.text('9+');
            } else {
                this.cartIcon.text(num);
            }
        } else {
            this.cartIcon.text(0);
        }
    }

    setupCheckoutItems(data, code) {
        const t = this;

        this.cartItems.html('');

        data.forEach((dataEl)=>{

            let customArr = dataEl.customAttributes;
            let customAttributes = {};

            if(customArr && customArr.length) {
                customArr.forEach((el)=>{
                    customAttributes[el.key] = el.value;
                });
            }

            // console.log(customAttributes);

            let selectInput = '';

            let cross = $('.cart-close-arrow');

            selectInput += `<option></option>`;

            let size = 21;

            if(dataEl.quantity > 20) {
                size = dataEl.quantity + 1;
            }

            for(var temp = 1; temp < size; temp++) {
                if(dataEl.quantity == temp) {
                    selectInput += `<option value="${temp}" selected>${temp}</option>`;
                } else {
                    selectInput += `<option value="${temp}">${temp}</option>`;
                }
            }

            // console.log(dataEl);

            let newEl =`<div class="cart-item" data-id="${dataEl.id}">` +
                            `<div class="cart-item-image">` +
                                `<img src="${dataEl.variant.image.src}" />` +
                            `</div>` +
                            `<div class="cart-item-info">` +
                                `<div class="cart-item-content">` +
                                    `<div class="cart-item-content_item cart-item_title">${dataEl.title}</div>` +
                                    `<div class="cart-item-content_item cart-item_summary">${customAttributes.summary}</div>` +
                                    // `<div class="cart-item-content_item cart-item_weight">${dataEl.variant.weight + 'g'}</div>` +
                                `</div>` +
                                `<div class="cart-item-tools">` +
                                    `<div class="cart-item_update"><select>${selectInput}</select></div>` +
                                    `<div class="cart-item-content_item cart-item_price">$${(dataEl.quantity * dataEl.variant.price).toFixed(2)}<span class="cart-item_price-code">${code}</span></div>` +
                                `</div>` +
                                `<div class="cart-item-remove">` +
                                    `<div class="cart-item_remove">${cross.html()}</div>` +
                                `</div>` +
                            `</div>` +
                        `</div>`;

            newEl = $(newEl);

            // input
            newEl.find('.cart-item_update select').change(_.debounce(function(){
                const $this = this;
                const item = $this.closest('.cart-item');
                const id = $(item).data('id');
                const $price = $(item).find('.cart-item_price');

                let value = parseInt($(this).val());
                if(value <= 0) {
                    t.removeProductFromCart(newEl, [
                        id
                    ]);
                } else {
                    if(value > 0) {
                        t.updateProductInCart([
                            {
                                id: id,
                                quantity: value
                            }
                        ]);
                        $($price).html(
                            `$${(value * dataEl.variant.price).toFixed(2)}<span class="cart-item_price-code">${code}</span>`
                        );
                    }
                }
            }, 250));
    
            newEl.find('.cart-item_remove').click(function(){
                const $this = this;
                const item = $this.closest('.cart-item');
                const id = $(item).data('id');
    
                t.removeProductFromCart(newEl, [
                    id
                ]);
            });
    
            this.cartItems.append(newEl);
        });
    }

    createNewCheckout() {
        this.shopifyClient.checkout.create().then((checkout) => {
            this.checkoutId = checkout.id;
            this.checkoutUrl = checkout.webUrl;
            this.setCookie(checkout.id);
            this.setupSubTotal(checkout.totalPrice);

            // console.log('checkout: ', checkout);

            if(checkout.lineItems.length == 0) {
                $('.cart-buttons_checkout').attr('disabled', 'true');
            }
        });
    }

    setupCheckoutInfo() {
        const t = this;

        if(this.cookie) {
            this.checkoutId = this.getCookie();

            this.shopifyClient.checkout.fetch(this.checkoutId).then((checkout) => {

                if(checkout.completedAt == null) {
                    this.checkoutUrl = checkout.webUrl;

                    // console.log('checkout: ', checkout);
    
                    this.setupSubTotal(checkout.totalPrice);
    
                    if(checkout.lineItems.length == 0) {
                        $('.cart-buttons_checkout').attr('disabled', 'true');
                    } else {
                        $('.cart-buttons_checkout').removeAttr('disabled');
    
                        this.setupCheckoutItems(checkout.lineItems, checkout.currencyCode);
                        this.updateCartIcon(checkout.lineItems);
                    }
                } else {
                    t.createNewCheckout();
                }
            });

        } else {
            t.createNewCheckout();
        }

        $('.cart-buttons_checkout').off('click');
        $('.cart-buttons_checkout').click(function(){
            window.location = t.checkoutUrl;
        });
    }

    setupCartContainer(iconClass) {
        if($('.cart-container').length != 0) {
            this.cartContainer = $('.cart');
            this.cartItems = this.cartContainer.find('.cart-items');

            this.setupCartIcon(iconClass);
        }
    }

    addProductToCart(lineItemsToAdd) {
        const t = this;
        this.shopifyPromise().then((success) => {
            this.shopifyClient.checkout.addLineItems(this.checkoutId, lineItemsToAdd).then((checkout) => {
                // console.log(checkout);
                
                this.updateCartIcon(checkout.lineItems);
                this.setupCheckoutItems(checkout.lineItems, checkout.currencyCode);
                this.setupSubTotal(checkout.totalPrice);
                
                if(checkout.lineItems.length > 0) {
                    $('.cart-buttons_checkout').removeAttr('disabled');
                }

                t.toggleCart();
            }).catch(function(e){
                console.error('e: ', e);
            });
        });
    }

    removeProductFromCart(el, lineItemIdsToRemove) {
        this.shopifyPromise().then((success) => {
            this.shopifyClient.checkout.removeLineItems(this.checkoutId, lineItemIdsToRemove).then((checkout) => {
                this.updateCartIcon(checkout.lineItems);
                this.setupSubTotal(checkout.totalPrice);

                if(checkout.lineItems.length == 0) {
                    $('.cart-buttons_checkout').attr('disabled', 'true');
                }

                el.remove();
            });
        });
    }

    updateProductInCart(lineItemsToUpdate) {
        // const lineItemsToUpdate = [
        //   {id: 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0Lzc4NTc5ODkzODQ=', quantity: 2}
        // ];

        this.shopifyPromise().then((success) => {
            this.shopifyClient.checkout.updateLineItems(this.checkoutId, lineItemsToUpdate).then((checkout) => {
                this.updateCartIcon(checkout.lineItems);
                this.setupSubTotal(checkout.totalPrice);
                if(checkout.lineItems.length == 0) {
                    $('.cart-buttons_checkout').attr('disabled', 'true');
                }
            });        
        
        });
    }
}


// WEBPACK FOOTER //
// ./source/scripts/utils/shopify.js